// extracted by mini-css-extract-plugin
module.exports = {"root":"Kodex_root__2mENc","lastUpdated":"Kodex_lastUpdated__36Hm3"};